import {

    createSlice,
    PayloadAction,
    SliceCaseReducers,
    ValidateSliceCaseReducers
} from '@reduxjs/toolkit'

export type GenericState<T> = {
    data: T | null;
    status: 'not_loaded' | 'loading' | 'finished' | 'error';
    error: string | null;
}

export interface GenericActions<T> {
    loading: () => void;
    success: (data: T) => void;
    error: (message: string) => void;
    reset: () => void;
}

export function createGenericSlice<
    T,
    Reducers extends SliceCaseReducers<GenericState<T>>
>({
    name = '',
    initialState,
    reducers,
    extraReducers
}: {
    name: string;
    initialState: GenericState<T>;
    reducers: ValidateSliceCaseReducers<GenericState<T>, Reducers>;
    extraReducers?: any;
}) {
    return createSlice({
        name,
        initialState,
        reducers: {
            loading: (state: { status: string }) => {
                state.status = 'loading'
            },
            success: (state: GenericState<T>, action: PayloadAction<T>) => {
                state.status = 'finished'
                state.data = action.payload

            },
            error: (state: { errors: any; status: string }, action: { payload: any }) => {
                state.errors = action.payload
                state.status = 'error'
            },
            reset: (state: { data: never[]; loadedInitial: boolean }) => {
                state.data = [];
                state.loadedInitial = false
            },
            ...reducers,
        },
        extraReducers,
    })
}